<template>
  <div class="page-import">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>导入导出记录</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}记录</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}错误记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="btn_box">
        <el-button :loading="isBtnLoading" size="small" type="danger" @click="pushStorage" v-if="pageTitle == '批量入职'">强制入库</el-button>
        <el-button v-if="!isNull(tableData)" :loading="btnLoading" size="small" type="primary" class="com_dialog_btn" @click="exportHandle">导出</el-button>
      </div>
      <el-table ref="multipleTable" class="re_table" v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" @selection-change="handleSelectionChange" :data="tableData" style="width:100%">
        <el-table-column type="selection" align="center" width="45" fixed="left">
        </el-table-column>
        <template v-for="(item,index) in tableTitle">
          <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1||item.StrColumName.indexOf('学历')>-1 ? '50px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('协议')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('推荐人')>-1||item.StrColumName.indexOf('到期')>-1||item.StrColumName.indexOf('二要素')>-1?'200px':'110px'" align="center" :fixed="item.StrColumName=='姓名'">
            <template slot-scope="{row}">
              <span>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.pagecount" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import xz from "./../../common.vue";
  export default {
    name: "importErrorList",
    data() {
      return {
        tableHeight: 0,
        pageTitle: "简历导入",
        tableLoading: false,
        btnLoading: false,
        tableData: [],
        listQuery: {
          currpage: 1,
          pagecount: 10,
          tableid: "JB_busi_PsnBaseImperr",
          strExcelPath: "",
        },
        tableTitle: [],
        // 表头参数
        titleQuery: {
          strTableId: "JB_busi_PsnBaseImperr",
          strIsFixed: "", // 1 基础 0 扩展 空 所有
        },
        total: 0,
        // 导出参数
        exportQuery: {
          strExcelPath: "",
          ststus: "简历错误导出",
          tableid: "JB_busi_PsnBaseImperr",
          currpage: 1, // 分页
          pagecount: 10000000,
        },
        multipleSelection: [],
        isBtnLoading: false
      };
    },
    created() {
      this.listQuery.strExcelPath = this.$route.query.strExcelPath;
      let actives = this.$route.query.activeTab;
      if (!this.isNull(actives)) {
        if (actives == "second") {
          this.pageTitle = "批量到面";
          this.exportQuery.ststus = "批量到面错误导出";
        } else if (actives == "third") {
          this.pageTitle = "批量入职";
          this.exportQuery.ststus = "批量入职错误导出";
        } else {
          this.pageTitle = "简历导入";
          this.exportQuery.ststus = "简历错误导出";
        }
      } else {
        this.pageTitle = "简历导入";
        this.exportQuery.ststus = "简历错误导出";
      }
      if (!this.isNull(this.$route.query.strTableId)) {
        this.titleQuery.strTableId = this.$route.query.strTableId;
        this.titleQuery.tableid = this.$route.query.strTableId;
        this.listQuery.tableid = this.$route.query.strTableId;
      } else {
        this.titleQuery.strTableId = "JB_busi_PsnBaseImperr";
        this.titleQuery.tableid = "JB_busi_PsnBaseImperr";
      }
      this.getTableTitleLists();
    },
    methods: {
      // 导出
      exportHandle() {
        this.btnLoading = true;
        this.exportQuery.strExcelPath = this.listQuery.strExcelPath;
        this.exportQuery.tableid = this.listQuery.tableid;
        // console.log('kk',this.exportQuery)
        xz.outputResumeList("4", this.exportQuery).then((res) => {
          if (res.status == "ok") {
            this.$router.push({
              path: "/resImportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                active: "导入导出记录",
                //qStstus=1时查看最后一条导出记录
                qStstus: 1,
              },
            });
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error",
            });
          }
          this.btnLoading = false;
        });
      },
      // 获取表头
      getTableTitleLists() {
        xz.getJbbasePageColumnList(
          this.titleQuery.strTableId,
          this.titleQuery.strIsFixed
        ).then((res) => {
          if (res.status == "ok") {
            this.tableTitle = res.msg;
            this.getList();
          } else {
            this.tableTitle = [];
          }
          // console.log('getList', this.tableTitle)
        });
      },
      // 获取列表
      getList() {
        this.tableLoading = true;
        xz.getErrtPsnImpDataList(this.listQuery).then((res) => {
          // console.log('getList', res)
          if (res.status == "ok") {
            this.tableData = res.msg;
            this.total = res.totalcount;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.tableLoading = false;
        });
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.listQuery.currpage = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pagecount = Number(val);
        this.getList();
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        //   console.log('height',this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          o == "1900-01-01" ||
          o == "1900-01-01T00:00:00"
        );
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      pushStorage() {
        if (this.multipleSelection.length > 0) {
          this.isBtnLoading = true
          let arr = []
          this.multipleSelection.forEach(item => {
            arr.push(item)
          })
          xz.RelmpEmp(arr, localStorage.loginRoletype).then(res => {
            if (res.status == "ok") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.isBtnLoading = false
              this.getList();
            } else {
              this.isBtnLoading = false
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          })
        } else {
          this.$message({
            message: "请选择要操作的数据",
            type: "error",
          });
        }
      },
    },
  };
</script>
<style scoped>
  .btn_box {
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
    padding: 10px 10px 10px 0;
  }
</style>